import { useLayoutEffect, type RefObject } from 'react';

const CURSOR_OFFSET = 16;
const VIEWPORT_MARGIN = 8;

/** Where a box of `size` goes beside the cursor at `at`: after it, or before it when that would leave the viewport. */
export const placeBeside = (at: number, size: number, viewport: number) => {
  const after = at + CURSOR_OFFSET;
  if (after + size <= viewport - VIEWPORT_MARGIN) return after;
  return Math.max(VIEWPORT_MARGIN, at - CURSOR_OFFSET - size);
};

/** Keeps a `position: fixed` element beside the cursor after every render, flipping to stay on screen. */
export const useBesideCursor = (
  ref: RefObject<HTMLElement | null>,
  clientX: number,
  clientY: number
) => {
  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;
    const { width, height } = node.getBoundingClientRect();
    node.style.left = `${placeBeside(clientX, width, window.innerWidth)}px`;
    node.style.top = `${placeBeside(clientY, height, window.innerHeight)}px`;
  });
};
